import { LAYOUT_COMPONENT_TYPE, REGISTRY_BLOCK, type LayoutBlock } from '@web-studio/shared-schemas';
import { loc3 } from '../locales';
import { FIXTURE_BLOCK_IDS } from '../uuids';

export const socialFeedGridDefault: LayoutBlock = {
  blockId: FIXTURE_BLOCK_IDS.socialFeed,
  componentType: LAYOUT_COMPONENT_TYPE.socialFeedGrid,
  registryBlockKey: REGISTRY_BLOCK.presentation.socialFeedGrid,
  displayOrder: 5,
  content: {
    sectionTitle: loc3('Aus dem Feed', 'From the feed', 'Từ feed'),
    handle: loc3('@muhlgasse.kaffee', '@muhlgasse.coffee', '@muhlgasse.coffee'),
    posts: loc3(
      'Latte Art Morgen — 2 Std.\nWeekend Pastries — gestern\nFilter Brew Special — 4 Std.',
      'Latte art morning — 2h\nWeekend pastries — yesterday\nFilter brew special — 4h',
      'Latte art sáng — 2 giờ\nBánh cuối tuần — hôm qua\nFilter đặc biệt — 4 giờ',
    ),
  },
  media: {},
};
